import { useEffect } from 'react';
import { useAemConfig } from '@as-react/common-components';
import { default as ScriptLoaderUtil } from '../util/ScriptLoaderUtil';
import { makeCommercialSize, makeOriginalSize } from '../util/ProductUtil';
const TRACKER_KEY = 'sizebay-script';
const TRACKER_SCRIPT = 'https://vfr-v3-production.sizebay.technology/V4/implantation/index.js';
const tenantIdRegexp = new RegExp(/\/(\d+)\//);
export const useSizebay = (order) => {
    const { sizebayScript } = useAemConfig();
    useEffect(() => {
        var _a;
        if (!order || !sizebayScript)
            return;
        const tenantId = (_a = tenantIdRegexp.exec(sizebayScript)) === null || _a === void 0 ? void 0 : _a[1];
        if (!tenantId)
            return;
        ScriptLoaderUtil.loadScript(TRACKER_SCRIPT, TRACKER_KEY).then(() => {
            var _a, _b, _c;
            (_c = (_b = (_a = window.Sizebay) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.ordered) === null || _c === void 0 ? void 0 : _c.call(_b, {
                orderId: order.orderNumber,
                items: order.mappedProducts.map(product => ({
                    permalink: `${window.location.origin}/${product.productCode}`,
                    price: product.price,
                    quantity: product.quantity,
                    size: product.size.commercialSizeDefault
                        ? makeCommercialSize(product.size)
                        : makeOriginalSize(product.size),
                    feedProductId: product.colorId,
                    sku: product.sku,
                })),
            }, tenantId);
        });
    }, [order, sizebayScript]);
};
